import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const data = {
  labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  datasets: [
    {
      type: "bar",
      label: "Accounts Created",
      data: [25, 34, 28, 25, 20, 24, 30],
      backgroundColor: "rgba(173, 216, 230, 0.5)",
      borderColor: "rgba(173, 216, 230, 1)",
      borderWidth: 1,
      yAxisID: "y",
      barPercentage: 0.7,
      categoryPercentage: 0.7,
      order: 1,
    },
    {
      type: "line",
      label: "Active Patients",
      data: [20, 21, 33, 30, 13, 19, 33],
      borderColor: "#226622",
      backgroundColor: "#226622",
      borderWidth: 2,
      pointBackgroundColor: "#226622",
      tension: 0.4,
      fill: false,
      yAxisID: "y",
      order: 0,
    },
    {
      type: "line",
      label: "Partially Registered",
      data: [11, 12, 9, 11, 12, 8, 13],
      borderColor: "#ffac33",
      backgroundColor: "#ffac33",
      borderWidth: 2,
      pointBackgroundColor: "#ffac33",
      borderDash: [6, 3],
      tension: 0.4,
      fill: false,
      yAxisID: "y",
      order: 0,
    },
    {
      type: "line",
      label: "Opt-Out Patients",
      data: [7, 3, 5, 6, 6, 2, 5],
      borderColor: "#ff3333",
      backgroundColor: "#ff3333",
      borderWidth: 2,
      pointBackgroundColor: "#ff3333",
      borderDash: [2, 2],
      tension: 0.4,
      fill: false,
      yAxisID: "y",
      order: 0,
    },
    {
      type: "line",
      label: "Inactive Patients",
      data: [16, 21, 14, 20, 19, 19, 23],
      borderColor: "#a259d9",
      backgroundColor: "#a259d9",
      borderWidth: 2,
      pointBackgroundColor: "#a259d9",
      borderDash: [1, 3],
      tension: 0.4,
      fill: false,
      yAxisID: "y",
      order: 0,
    },
    {
      type: "line",
      label: "Total Onboarded",
      data: [31, 42, 39, 44, 25, 30, 30],
      borderColor: "#26d9ff",
      backgroundColor: "#26d9ff",
      borderWidth: 2,
      pointBackgroundColor: "#26d9ff",
      tension: 0.4,
      fill: false,
      yAxisID: "y",
      order: 0,
    },
    {
      type: "line",
      label: "Unresponsive Patients",
      data: [25, 28, 25, 30, 20, 24, 30],
      borderColor: "#bbbbbb",
      backgroundColor: "#bbbbbb",
      borderWidth: 2,
      pointBackgroundColor: "#bbbbbb",
      borderDash: [5, 5],
      tension: 0.4,
      fill: false,
      yAxisID: "y",
      order: 0,
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "right",
      labels: {
        usePointStyle: true,
        padding: 20,
        boxWidth: 14,
      },
    },
    title: {
      display: false,
    },
    tooltip: {
      mode: "index",
      intersect: false,
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Days of the Week",
      },
      grid: {
        display: false,
      },
    },
    y: {
      title: {
        display: true,
        text: "Accounts Created",
        color: "#2a2aff",
        font: { weight: "bold" },
      },
      min: 0,
      max: 35,
      ticks: {
        stepSize: 5,
      },
      grid: {
        color: "#ccc",
      },
    },
  },
  interaction: {
    mode: "nearest",
    intersect: false,
  },
};

export default function TrendBreakdownChart({ onClose }) {
  return (
    <div
      style={{
        background: "white",
        borderRadius: 24,
        padding: "5vw",
        boxShadow: "0 0 16px #ccc",
        width: "90%",
        maxWidth: 1200,
        // margin: "20px",
        minHeight: "40vw",
        minWidth: 0,
        boxSizing: "border-box",
        position: "relative",
      }}
    >
      <button
        onClick={() => onClose()}
        style={{
          position: "absolute",
          top: 16,
          right: 16,
          background: "transparent",
          border: "none",
          fontSize: "24px",
          fontWeight: "bold",
          color: "#666",
          cursor: "pointer",
        }}
      >
        ×
      </button>
      <h2 style={{ fontWeight: 700, marginBottom: 16 }}>Trend breakdown</h2>
      <Chart type="bar" data={data} options={options} />
      <div style={{ textAlign: "center", marginTop: 24 }}>
        <button
          onClick={onClose}
          style={{
            background: "#06c167",
            color: "white",
            border: "none",
            borderRadius: 8,
            padding: "10px 32px",
            fontWeight: 600,
            fontSize: 16,
            cursor: "pointer",
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
}
